import React from 'react'
import TourismImage from './TourismImage'
import TourismText from './TourismText'
import TourismHero from './TourismHero'
import TourismServices from './TourismServices'
import Footer from '../../pages/Footer/Footer'

const Tourism = () => {
  return (
    <>
      <TourismImage/>
      <TourismText/>
      <TourismHero/>
      <TourismServices/>
      <Footer/>
    </>
  )
}

export default Tourism
